import {
    getDiffDays,
    getDiffHours,
    getDiffQuarterDays,
    getDiffHalfDays,
    returnDateInfo,
    getMonday
} from './dateVariables';

export const humaniseDatakeyNewShift = {
    vbasid: 'Base (obligatorisk)',
    crewkd: 'Crew (obligatorisk)',
    fra: 'Start (obligatorisk)',
    til: 'Slutt (obligatorisk)',
    type: 'type (obligatorisk)',
    subtype: 'subtype (obligatorisk)',
    reason: 'reason (obligatorisk)',
    avdelingsnummer: 'avdelingsnummer (obligatorisk)',
    virksomhetområde: 'virksomhetområde (obligatorisk)',
    person: 'valg av crew som skal bemanne vakten',
    kommentar: 'Kommentar til vakt',
    loggmelding: 'Loggmelding til vakt'
};

export const getBaseTypeFromBaseID = (base, vaktBaser) => {
    let foundBase = vaktBaser.find((el) => el.baseid == base);
    if (foundBase) return foundBase.base_type;
    return 0;
};

export const shiftTypes = {
    Base: '1',
    Bakvakt: '2',
    Simulator: '3',
    'RTV/OV': '4',
    Ferie: '5',
    Fravær: '6',
    Kurs: '7',
    Øvrig: '88'
};

export const statText = {
    0: 'ulest',
    1: 'Lest',
    2: 'Under behandling',
    3: 'Venter på svar',
    7: 'Ferdig (ok)',
    8: 'Ferdig (nei)'
};

export const deepCloneArray = (items) => JSON.parse(JSON.stringify(items)); // items.map(item => Array.isArray(item) ? clone(item) : item);

export const getWidth = () =>
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

const noneChecked = (obj) => {
    let someChecked = false;
    Object.keys(obj).forEach((key) => {
        if (obj[key].checked) someChecked = true;
    });
    return !someChecked;
};

const CreateEmptyShiftObj = (obj, startC, oId) => {
    return {
        ...obj,
        startColumn: startC,
        id: oId
    };
};
export const arrangeCalendarVakter = (
    vakter,
    filters,
    yAxis,
    offsetFromWeek,
    wks,
    ignoreGoTo,
    maxShow
) => {
    // calendar jazz
    let rowObj = {};
    let weekOffset = new Date();
    var dayParts = 24;
    if (maxShow >= 7 && maxShow <= 26) dayParts = 4;
    else if (maxShow >= 52) dayParts = 2;
    const weekInterval = dayParts * 7;
    const endGrid = wks * weekInterval + 1;
    if (parseInt(offsetFromWeek)) {
        weekOffset.setDate(weekOffset.getDate() + offsetFromWeek * 7);
    }
    let dateInf = getMonday(weekOffset);
    let endDateInf = new Date(dateInf.dateVar);
    endDateInf.setDate(endDateInf.getDate() + wks * 7);
    endDateInf.setMinutes(endDateInf.getMinutes() - 1);
    endDateInf = returnDateInfo(endDateInf);

    let vakterWorkW = vakter.filter((itm) => {
        let ret = false;
        const start = new Date(itm.start);
        const end = new Date(itm.end);
        if (start >= dateInf.dateVar && start < endDateInf.dateVar) ret = true;
        else if (end >= dateInf.dateVar && end <= endDateInf.dateVar)
            ret = true;
        else if (dateInf.dateVar > start && dateInf.dateVar < end) ret = true;

        return ret;
    });

    vakterWorkW.forEach((vakt) => {
        const isShowing =
            (filters[vakt.base_type] && filters[vakt.base_type].checked) ||
            (!filters[vakt.base_type] &&
                filters['88']?.checked &&
                vakt.base_type != 6) ||
            (filters[1]?.checked && vakt.base_type == 9) ||
            noneChecked(filters);

        if (isShowing) {
            let yRowName;
            if (yAxis === 'base') {
                if (
                    vakt.baseid == 22 ||
                    vakt.baseid == 23 ||
                    vakt.baseid == 24
                ) {
                    let vaktNavnDelt = vakt.base.split(' ');
                    yRowName =
                        vaktNavnDelt[0] +
                        (vakt.crewkd === 10 ? ' HCM ' : ' Pilot ') +
                        vaktNavnDelt[1];
                } else
                    yRowName =
                        vakt.base + (vakt.crewkd === 10 ? ' HCM' : ' Pilot');
            } else if (yAxis === 'crew') yRowName = vakt.navn;

            if (!(yAxis === 'crew' && vakt.usid == 0)) {
                if (!rowObj[yRowName]) {
                    const robj = {
                        baselabel: yRowName,
                        crewType: vakt.crewkd,
                        basetype: vakt.base_type,
                        weeks: {},
                        yAxis: yAxis
                    };
                    if (yAxis === 'crew') {
                        rowObj[yRowName] = {
                            ...robj,
                            navn: yRowName,
                            show: isShowing,
                            usid: vakt.usid
                        };
                    } else {
                        rowObj[yRowName] = {
                            ...robj,
                            baseid: vakt.baseid,
                            navn: vakt.baseid,
                            show: isShowing
                        };
                    }
                }
                if (!rowObj[yRowName].shifts) {
                    rowObj[yRowName].shifts = [];
                }

                const vaktDiff = getDiffDays(vakt.start, vakt.end);
                const label = yAxis == 'crew' ? vakt.base : vakt.vaktnavn;

                const initDate = dateInf.dateVar;

                const dInf = returnDateInfo(vakt.start);
                const endInf = returnDateInfo(vakt.end);

                var diffFromInit, diffToEnd;

                if (maxShow >= 7 && maxShow <= 26) {
                    diffFromInit = getDiffQuarterDays(initDate, dInf.dateVar);
                    diffToEnd = getDiffQuarterDays(initDate, endInf.dateVar);
                } else if (maxShow >= 52) {
                    diffFromInit = getDiffHalfDays(initDate, dInf.dateVar);
                    diffToEnd = getDiffHalfDays(initDate, endInf.dateVar);
                } else {
                    diffFromInit = getDiffHours(initDate, dInf.dateVar);
                    diffToEnd = getDiffHours(initDate, endInf.dateVar);
                }

                const intV = parseInt(diffFromInit);
                let startOffset = intV + 1;
                if (startOffset < 1) startOffset = 1;

                const intE = parseInt(diffToEnd);
                let endOffset = intE + 1;

                if (endOffset > endGrid) endOffset = endGrid;

                if (startOffset === endOffset) {
                    //give some grid. should never happen but maybe something is registered with only half an hour?
                    if (endOffset === endGrid) startOffset -= 1;
                    else endOffset++;
                }

                let newObj = {
                    ...vakt,
                    antDager: vaktDiff,
                    vaktLabel: label,
                    initDate: initDate,
                    startColumn: startOffset,
                    endColumn: endOffset
                };
                rowObj[yRowName].shifts.push(newObj);
            }
        }
    });

    let yearHeaders = [];
    let monthHeaders = [];
    let weekHeaders = [];
    let dayHeaders = [];
    let i = 1;
    let prevDate;
    for (
        var d = new Date(dateInf.dateVar);
        d <= endDateInf.dateVar;
        d.setDate(d.getDate() + 1)
    ) {
        let dateI = returnDateInfo(d);
        let endY, endM, startY, startM, startW, endW;
        if (i === 1) {
            startY = startM = startW = 1;
        } else if (prevDate && prevDate.month != dateI.month) {
            startM = i * dayParts - dayParts;
            monthHeaders[monthHeaders.length - 1].endColumn = startM;
            if (prevDate && prevDate.year != dateI.year) {
                //change grid
                startY = startM;
                yearHeaders[yearHeaders.length - 1].endColumn = startY;
            }
        }
        if (prevDate && prevDate.week != dateI.week) {
            startW = i * dayParts - dayParts;
            weekHeaders[weekHeaders.length - 1].endColumn = startW;
        }
        if (!yearHeaders.find((el) => el.year == dateI.year)) {
            if (endDateInf.year == dateI.year) endY = endGrid;
            yearHeaders.push({
                year: dateI.year,
                startColumn: startY,
                endColumn: endY
            });
        }
        if (!monthHeaders.find((el) => el.month == dateI.month)) {
            if (endDateInf.month == dateI.month) endM = endGrid;
            monthHeaders.push({
                monthStr: dateI.monthStr,
                month: dateI.month,
                startColumn: startM,
                endColumn: endM
            });
        }
        if (!weekHeaders.find((el) => el.week == dateI.week)) {
            if (endDateInf.week == dateI.week) endW = endGrid;
            weekHeaders.push({
                year: dateI.year,
                week: dateI.week,
                startColumn: startW,
                endColumn: endW
            });
        }

        let startCol, endCol;

        startCol = i * dayParts - dayParts;
        endCol = i * dayParts;

        if (startCol == 0) {
            startCol = 1;
        }

        dayHeaders.push({ ...dateI, startColumn: startCol, endColumn: endCol });
        i++;
        prevDate = dateI;
    }

    let futureHeaders = {};

    for (let i = 0; i < wks; i++) {
        let wmday;
        if (i === 0) {
            wmday = dateInf;
        } else {
            const dti = new Date(dateInf.dateVar);
            dti.setDate(dti.getDate() + 7 * i); //next monday
            wmday = returnDateInfo(dti);
        }
        if (wmday) {
            let endWDate = new Date(wmday.dateVar);
            endWDate.setDate(wmday.dateVar.getDate() + 6);
            endWDate.setHours(23, 59, 59, 59);

            const lbs = `${wmday.year}W${wmday.week}`;
            futureHeaders[lbs] = {
                ...wmday,
                lbl: lbs,
                startW: wmday.dateVar,
                endW: endWDate
            };
        }
    }
    if (ignoreGoTo !== true) {
        Object.keys(rowObj).forEach((key) => {
            let arrWEmpty = [...rowObj[key].shifts];
            rowObj[key].shifts = sortThis(rowObj[key].shifts, {
                key: 'startColumn',
                direction: 'asc'
            });
            for (let i = 0; i < rowObj[key].shifts.length; i++) {
                let nObj = {
                    isEmpty: true,
                    base: rowObj[key].shifts[i].base,
                    usid: 0,
                    color: 'rgba(164, 162, 159, 0.1)'
                };
                let weekNo = 1;
                let startC;
                let startD;

                if (i === 0 && rowObj[key].shifts[i].startColumn > 1) {
                    startC = 1;
                    startD = new Date(dateInf.dateVar);
                    do {
                        if (arrWEmpty.at(-1).isEmpty) {
                            let prev = arrWEmpty.at(-1).id.split('.');
                            if (
                                arrWEmpty.at(-1).id ==
                                `XST${rowObj[key].shifts[i].id}-${weekNo}`
                            )
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}.1`
                                );
                            else if (
                                prev.length > 1 &&
                                prev[0] ==
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}`
                            ) {
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}.${
                                        parseInt(prev[1]) + 1
                                    }`
                                );
                            } else
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}`
                                );
                        } else
                            nObj = CreateEmptyShiftObj(
                                nObj,
                                startC,
                                `XST${rowObj[key].shifts[i].id}-${weekNo}`
                            );

                        nObj.start = new Date(startD);
                        startD.setDate(startD.getDate() + 7);
                        if (
                            rowObj[key].shifts[i].startColumn >
                            weekNo * weekInterval
                        ) {
                            nObj.endColumn = weekNo * weekInterval + 1;
                            startC = weekNo * weekInterval + 1; //for next loop
                            weekNo++;
                        } else {
                            nObj.endColumn = rowObj[key].shifts[i].startColumn;
                            weekNo = endGrid + 1;
                        }
                        arrWEmpty.push(nObj);
                    } while (weekNo * weekInterval < endGrid);
                }
                if (rowObj[key].shifts[i + 1]) {
                    //if not the last one
                    if (
                        rowObj[key].shifts[i].endColumn <
                        rowObj[key].shifts[i + 1].startColumn
                    ) {
                        startC = rowObj[key].shifts[i].endColumn;
                        startD = new Date(rowObj[key].shifts[i].end_iso);
                        weekNo = parseInt(startC / weekInterval) + 1;

                        do {
                            if (arrWEmpty.at(-1).isEmpty) {
                                let prev = arrWEmpty.at(-1).id.split('.');
                                if (
                                    arrWEmpty.at(-1).id ==
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}`
                                )
                                    nObj = CreateEmptyShiftObj(
                                        nObj,
                                        startC,
                                        `XST${rowObj[key].shifts[i].id}-${weekNo}.1`
                                    );
                                else if (
                                    prev.length > 1 &&
                                    prev[0] ==
                                        `XST${rowObj[key].shifts[i].id}-${weekNo}`
                                ) {
                                    nObj = CreateEmptyShiftObj(
                                        nObj,
                                        startC,
                                        `XST${
                                            rowObj[key].shifts[i].id
                                        }-${weekNo}.${parseInt(prev[1]) + 1}`
                                    );
                                } else
                                    nObj = CreateEmptyShiftObj(
                                        nObj,
                                        startC,
                                        `XST${rowObj[key].shifts[i].id}-${weekNo}`
                                    );
                            } else
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}`
                                );

                            nObj.start = new Date(startD);
                            startD.setDate(startD.getDate() + 7);
                            startD.setHours(0, 0, 0, 0);
                            startD = getMonday(startD);
                            startD = startD.dateVar;

                            if (
                                rowObj[key].shifts[i + 1].startColumn >
                                weekNo * weekInterval
                            ) {
                                //strekker seg over flere uker
                                nObj.endColumn = weekNo * weekInterval + 1;
                                startC = weekNo * weekInterval + 1; //for next loop
                                weekNo++;
                            } else {
                                nObj.endColumn =
                                    rowObj[key].shifts[i + 1].startColumn;
                                startC =
                                    rowObj[key].shifts[i + 1].startColumn + 1;
                            }
                            arrWEmpty.push(nObj);
                            //to only loop once:
                        } while (
                            startC < rowObj[key].shifts[i + 1].startColumn
                        );
                    }
                }
                if (
                    rowObj[key].shifts[i].endColumn < endGrid &&
                    !rowObj[key].shifts[i + 1]
                ) {
                    startC = rowObj[key].shifts[i].endColumn;
                    startD = new Date(rowObj[key].shifts[i].end_iso);
                    weekNo = parseInt(startC / weekInterval) + 1;
                    do {
                        if (arrWEmpty.at(-1).isEmpty) {
                            let prev = arrWEmpty.at(-1).id.split('.');
                            if (
                                arrWEmpty.at(-1).id ==
                                `XST${rowObj[key].shifts[i].id}-${weekNo}`
                            )
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}.1`
                                );
                            else if (
                                prev.length > 1 &&
                                prev[0] ==
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}`
                            ) {
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}.${
                                        parseInt(prev[1]) + 1
                                    }`
                                );
                            } else
                                nObj = CreateEmptyShiftObj(
                                    nObj,
                                    startC,
                                    `XST${rowObj[key].shifts[i].id}-${weekNo}`
                                );
                        } else
                            nObj = CreateEmptyShiftObj(
                                nObj,
                                startC,
                                `XST${rowObj[key].shifts[i].id}-${weekNo}`
                            );

                        nObj.start = new Date(startD);
                        startD.setDate(startD.getDate() + 7);
                        startD.setHours(0, 0, 0, 0);
                        startD = getMonday(startD);
                        startD = startD.dateVar;
                        if (endGrid > weekNo * weekInterval) {
                            //strekker seg over flere uker
                            nObj.endColumn = weekNo * weekInterval + 1;
                            startC = weekNo * weekInterval + 1; //for next loop
                            weekNo++;
                        } else {
                            nObj.endColumn = endGrid;
                            weekNo = endGrid + 1;
                        }
                        arrWEmpty.push(nObj);
                    } while (weekNo * weekInterval < endGrid);
                }
            }
            rowObj[key].shifts = arrWEmpty;
        });
    }
    return {
        rowObj: rowObj,
        futureHeaders,
        yearHeaders,
        monthHeaders,
        weekHeaders,
        dayHeaders
    };
};

export const returnInitFilter = (minimalFilter, filter) => {
    let obj = {};
    if (filter) obj = filter;
    else
        Object.keys(shiftTypes).forEach((shft) => {
            if (
                (minimalFilter &&
                    ['1', '2', '3', '4', '5', '7'].includes(
                        shiftTypes[shft]
                    )) ||
                !minimalFilter
            ) {
                obj[shiftTypes[shft]] = {
                    lbl: shft,
                    checked: shiftTypes[shft] == '1' ? true : false
                };
            }
        });
    return obj;
};

export const getInitials = (name) => {
    let ret = name;
    if (name && name.length > 0) {
        const spl = name.toUpperCase().split(' ');
        ret = spl[0].substring(0, 1);
        if (spl.length > 1) {
            ret = ret + spl[spl.length - 1].substring(0, 1);
        }
    }
    return ret;
};

export const sortThis = (array, sorting) => {
    if (array && array.length > 0) {
        var tempArr = [...array];
        return tempArr.sort((a, b) => {
            const hasSortKey = sorting.key;
            if (typeof (hasSortKey ? a[sorting.key] : a) === 'string') {
                const aK = (hasSortKey ? a[sorting.key] : a).toUpperCase();
                const bK = (hasSortKey ? b[sorting.key] : b).toUpperCase();
                if (aK < bK) return sorting.direction === 'asc' ? -1 : 1;
                if (aK > bK) return sorting.direction === 'asc' ? 1 : -1;
                return 0;
            } else
                return sorting.direction === 'desc'
                    ? (hasSortKey ? b[sorting.key] : b) -
                          (hasSortKey ? a[sorting.key] : a)
                    : (hasSortKey ? a[sorting.key] : a) -
                          (hasSortKey ? b[sorting.key] : a);
        });
    }
    return [];
};

export const setCheckedAndDisabled = (arr) => {
    if (Array.isArray(arr)) {
        return arr.map((item) => ({
            ...item,
            checked: false,
            disabled: false
        }));
    } else if (typeof arr === 'object') {
        let newObj = {};

        Obj.keys(arr).forEach((key) => {
            newObj[key] = { ...arr[key], checked: false, disabled: false };
        });
        return newObj;
    }
    return [];
};

export const updateCheck = (
    array,
    checked,
    nameField,
    nameVal,
    eChecked,
    multiple
) => {
    //to update a checklist (made for selectInput)
    return array.map((item) => {
        const itm = { ...item };
        itm[checked] =
            item[nameField] === nameVal
                ? eChecked
                : multiple
                ? item[checked]
                : false;

        return itm;
    });
};

export const baseInfo = (id, baseArray) => {
    const baseI = (baseArray || []).filter((base) => id == base.baseid);
    return baseI !== undefined && baseI.length > 0 ? baseI[0] : {};
};
